/**
 * Auth service
 */
export class AuthService {
  constructor() {
    this.isSeamlessLogin = false;
    this.seamlessError = false;

    this.authCallback = () => null;

    this.setAuthCallback = authCallback => {
      this.authCallback = authCallback;
      return this;
    };

    this.setSeamlessLogin = val => {
      this.isSeamlessLogin = val;
      return this;
    };

    this.getIsSeamlessLogin = () => {
      return this.isSeamlessLogin;
    };

    this.setSeamlessError = val => {
      this.seamlessError = val;
      return this;
    };

    this.getSeamlessLoginError = () => {
      return this.seamlessError;
    };
  }

  /**
   * Get instance
   *
   * @return {AuthService}
   */
  static getInstance() {
    if (this.myInstance === null) {
      this.myInstance = new AuthService();
    }

    return this.myInstance;
  }
  /**
   * Reauth after logout (only for mobile app)
   *
   * @return {function}
   */


}
AuthService.myInstance = null;